import { MetricKey } from 'hooks/useRoiAppointmentMetricBreakdown';

export const METRIC_KEYS: Record<string, MetricKey> = {
  APPTS_REQUESTED: 'appointment-requested',
  APPTS_ACCEPTED: 'appointment-accepted',
  SHOWS: 'appointment-completed',
  NEW_PATIENTS: 'new-patient',
  EXISTING_PATIENTS: 'existing-patient',
  PRODUCTION: 'production',
  APPTS_REJECTED_REASON: 'appointment-cancelled',
};

export type TableCellRenderer =
  | 'datetime'
  | 'avatar-name'
  | 'practitioner'
  | 'amount'
  | 'reason'
  | 'text';

export interface MetricColumn {
  id: string;
  label: string;
  width: string;
  sortable?: boolean;
  sortKey?: string;
  renderer?: TableCellRenderer;
}

export interface MetricOption {
  label: string;
  key: MetricKey;
  unitLabel: string;
  columns: MetricColumn[];
}

const APPT_COLUMNS: MetricColumn[] = [
  { id: 'apptDate', label: 'APPT DATE & TIME', width: 'flex-1', sortable: true, sortKey: 'apptDateTime', renderer: 'datetime' },
  { id: 'patient', label: 'PATIENT', width: 'flex-1', sortable: true, renderer: 'avatar-name' },
  { id: 'patientPhoneNumber', label: 'PHONE NUMBER', width: 'flex-1', renderer: 'text' },
  { id: 'practitioner', label: 'PRACTITIONER', width: 'flex-1', sortable: true, renderer: 'practitioner' },
  { id: 'service', label: 'SERVICE', width: 'flex-1', sortable: true, renderer: 'text' },
  { id: 'source', label: 'SOURCE', width: 'flex-1', sortable: true, renderer: 'text' },
  { id: 'requestedTime', label: 'REQUESTED TIME', width: 'flex-1', sortable: true, sortKey: 'requestedDateTime', renderer: 'text' },
];

const REJECTED_COLUMNS: MetricColumn[] = [
  { id: 'apptDate', label: 'APPT DATE & TIME', width: 'flex-1', sortable: true, sortKey: 'apptDateTime', renderer: 'datetime' },
  { id: 'patient', label: 'PATIENT', width: 'flex-1', sortable: true, renderer: 'avatar-name' },
  { id: 'patientPhoneNumber', label: 'PHONE NUMBER', width: 'flex-1', renderer: 'text' },
  { id: 'practitioner', label: 'PRACTITIONER', width: 'flex-1', sortable: true, renderer: 'practitioner' },
  { id: 'service', label: 'SERVICE', width: 'flex-1', sortable: true, renderer: 'text' },
  { id: 'source', label: 'SOURCE', width: 'flex-1', sortable: true, renderer: 'text' },
  { id: 'rejectedReason', label: 'REJECTED REASON', width: 'flex-1', sortable: true, renderer: 'reason' },
  { id: 'requestedTime', label: 'REQUESTED TIME', width: 'flex-1', sortable: true, sortKey: 'requestedDateTime', renderer: 'text' },
];

export const METRIC_OPTIONS: MetricOption[] = [
  {
    label: 'Appts Requested',
    key: METRIC_KEYS.APPTS_REQUESTED,
    unitLabel: 'appts',
    columns: APPT_COLUMNS,
  },
  {
    label: 'Appts Accepted',
    key: METRIC_KEYS.APPTS_ACCEPTED,
    unitLabel: 'appts',
    columns: APPT_COLUMNS,
  },
  {
    label: 'Shows',
    key: METRIC_KEYS.SHOWS,
    unitLabel: 'appts',
    columns: APPT_COLUMNS,
  },
  {
    label: 'New Patients',
    key: METRIC_KEYS.NEW_PATIENTS,
    unitLabel: 'new patients',
    columns: APPT_COLUMNS,
  },
  {
    label: 'Existing Patients',
    key: METRIC_KEYS.EXISTING_PATIENTS,
    unitLabel: 'existing patients',
    columns: APPT_COLUMNS,
  },
  {
    label: 'Production',
    key: METRIC_KEYS.PRODUCTION,
    unitLabel: 'production',
    columns: APPT_COLUMNS,
  },
  {
    label: 'Appts Rejected (Reason)',
    key: METRIC_KEYS.APPTS_REJECTED_REASON,
    unitLabel: 'appts',
    columns: REJECTED_COLUMNS,
  },
];
